import { render } from "./AppMainMusteri.vue?vue&type=template&id=c82bf9c4"
import script from "./AppMainMusteri.vue?vue&type=script&lang=js"
export * from "./AppMainMusteri.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__